import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TrackingOpProvider } from "../../../contexts/TrackingOpContext";
import { IVesselOfUser } from '../../../pages/LoginPage/constants';
import { selectPermissions } from '../../../util/store/selectors';
import { useSelector } from "../../../util/store/store";
import { KEY_STORAGE } from '../../../util/varibles/constants';
import { IOperation2 } from "../../../util/varibles/interface";
import { ACTION } from '../../../util/varibles/permission';
import Loading from "../_components/Loading";
import Operation from "./Operation";
import styles from './style.module.scss';

interface IProps {
    onTracking?: (data: IOperation2 | { vessel: IVesselOfUser }) => void
    onUpdate?: (data: IOperation2) => void
}

const EMPTY_OPERATIONS: IOperation2[] = [];

const Operations: React.FC<IProps> = ({ onTracking, onUpdate }) => {
    const default_vessel = useSelector(state => state.login.user.default_vessel)
    const vessels = useSelector(state => state.login.vessels)
    const [permission] = useSelector(selectPermissions([ACTION.VESSEL_SIDE.UPDATE]))

    const vessel = useMemo(() => {
        return (vessels || []).find(item => item.vessel_id === default_vessel) || vessels?.[0];
    }, [default_vessel, vessels])
    const operations = vessel?.operations || EMPTY_OPERATIONS;
    const [active, setActive] = useState("");

    useEffect(() => {
        const oldId = localStorage.getItem(KEY_STORAGE.TRACKING_OP_ID) || "";
        const exists = operations.find(item => item.operation.id === oldId) || operations[0];
        const nextActive = exists?.operation.id || "";
        setActive(currentActive => currentActive === nextActive ? currentActive : nextActive)
    }, [operations])

    const handleOpen = useCallback((i: number) => {
        const { id } = vessel.operations?.[i]?.operation || {};
        setActive(vessel.operations?.[i]?.operation.id);
        localStorage.setItem(KEY_STORAGE.TRACKING_OP_ID, id)
        if (vessel)
            onTracking?.(vessel.operations?.[i] as IOperation2 || { vessel });
    }, [onTracking, vessel]);

    if (!permission)
        return null;

    return <>
        <Loading data={operations} />
        <div className={styles.operations}>
            {operations.map((item, i) => <TrackingOpProvider
                key={item.operation.id}
                op={item}
                active={active === item.operation.id}
                onExtend={() => handleOpen(i)}
                onUpdate={onUpdate}
            >
                <Operation />
            </TrackingOpProvider>)}
        </div>
    </>;
};

export default Operations;
